import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getMediaBaseUrl } from "../utils/backendUrl";

const Profilecard = ({ data, isDetail = false }) => {
  const { t } = useTranslation();
  const [showMore, setShowMore] = useState(isDetail);
  const [speaking, setSpeaking] = useState(false);
  const [muted, setMuted] = useState(false);
  const [reporterImgError, setReporterImgError] = useState(false);
  const [showShare, setShowShare] = useState(false);

  const article = Array.isArray(data) ? data[0] : data;

  // Always show full text if we are on the detail page
  useEffect(() => {
    if (isDetail) {
      setShowMore(true);
    }
  }, [isDetail]);

  useEffect(() => {
    if (article) {
      console.log("PROFILE ARTICLE:", article);
    }
  }, [article]);

  if (!article) return null;

  const handleListen = (text) => {
    if (!text) return;

    if (speaking) {
      window.speechSynthesis.cancel();
      setSpeaking(false);
      setMuted(true);
      return;
    }

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "hi-IN";
    utterance.rate = 0.9;

    utterance.onend = () => {
      setSpeaking(false);
      setMuted(false);
    };

    window.speechSynthesis.speak(utterance);
    setSpeaking(true);
    setMuted(false);
  };

  const rawDescription = article.description || "";
  const words = rawDescription.split(" ");

  const PREVIEW_WORDS = 50;
  const previewText = words.slice(0, PREVIEW_WORDS).join(" ");
  const remainingText = words.slice(PREVIEW_WORDS).join(" ");

  const handleShare = () => {
    setShowShare(true);
  };

  const handleCopyLink = async () => {
    const url = `${window.location.origin}/news/${article.id}`;
    try {
      await navigator.clipboard.writeText(url);
      alert("à¤²à¤¿à¤‚à¤• à¤•à¥‰à¤ªà¥€ à¤¹à¥‹ à¤—à¤¯à¤¾!");
    } catch (_) {
      window.prompt("à¤•à¥‰à¤ªà¥€ à¤•à¤°à¤¨à¥‡ à¤•à¥‡ à¤²à¤¿à¤ à¤²à¤¿à¤‚à¤•:", url);
    }
    setShowShare(false);
  };

  const handleCopyImageAndLink = async () => {
    const url = `${window.location.origin}/news/${article.id}`;
    try {
      let imageUrl = getThumbnailUrl();
      if (!imageUrl || typeof ClipboardItem === "undefined" || !navigator.clipboard?.write) {
        throw new Error("rich copy not supported");
      }

      const resp = await fetch(imageUrl);
      if (!resp.ok) throw new Error("image fetch failed");
      const blob = await resp.blob();
      const bitmap = await createImageBitmap(blob);
      const canvas = document.createElement("canvas");
      canvas.width = bitmap.width;
      canvas.height = bitmap.height;
      canvas.getContext("2d").drawImage(bitmap, 0, 0);
      bitmap.close();

      const pngBlob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
      if (!pngBlob) throw new Error("png conversion failed");

      await navigator.clipboard.write([
        new ClipboardItem({
          "text/plain": new Blob([url], { type: "text/plain" }),
          "image/png": pngBlob,
        }),
      ]);
      alert("à¤¥à¤‚à¤¬à¤¨à¥‡à¤² + à¤²à¤¿à¤‚à¤• à¤•à¥‰à¤ªà¥€ à¤¹à¥‹ à¤—à¤¯à¤¾! à¤…à¤¬ WhatsApp à¤ªà¤° à¤ªà¥‡à¤¸à¥à¤Ÿ à¤•à¤°à¥‡à¤‚à¥¤");
    } catch (_) {
      await handleCopyLink();
    }
    setShowShare(false);
  };

  const handleNativeShare = async () => {
    const url = `${window.location.origin}/news/${article.id}`;
    const title = article.news_title || "The Mandakini Times";
    if (!navigator.share) return;
    try {
      await navigator.share({ title, text: title, url });
    } catch (err) {
      if (err.name !== "AbortError") console.error(err);
    }
    setShowShare(false);
  };

  const handleWhatsAppShare = async () => {
    const url = `${window.location.origin}/news/${article.id}`;
    const title = article.news_title || "The Mandakini Times";
    const text = `${title}\n${url}`;

    // Mobile: try to send the actual thumbnail image via native share sheet
    if (navigator.share && typeof navigator.canShare === "function") {
      try {
        const imageUrl = getThumbnailUrl();
        if (imageUrl) {
          const resp = await fetch(imageUrl);
          if (resp.ok) {
            const blob = await resp.blob();
            const file = new File([blob], "thumbnail.jpg", { type: blob.type });
            const shareData = { text, files: [file] };
            if (navigator.canShare(shareData)) {
              await navigator.share(shareData);
              setShowShare(false);
              return;
            }
          }
        }
        await navigator.share({ title, text, url });
        setShowShare(false);
        return;
      } catch (err) {
        if (err.name !== "AbortError") console.error(err);
      }
    }

    // Fallback: open WhatsApp with the link (thumbnail shows via OG preview on public domain)
    window.open(`https://wa.me/?text=${encodedTitle}%20${encodedUrl}`, "_blank", "noopener");
    setShowShare(false);
  };

  const getThumbnailUrl = () => {
    if (!article.thumbnail) return "";
    if (article.thumbnail?.startsWith("http")) return article.thumbnail;
    if (article.thumbnail?.startsWith("/images/")) return `${window.location.origin}${article.thumbnail}`;
    return `${getMediaBaseUrl()}/uploads/news/${encodeURIComponent(article.thumbnail)}`;
  };

  const shareUrl = `${window.location.origin}/news/${article.id}`;
  const shareTitle = article.news_title || "The Mandakini Times";
  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedTitle = encodeURIComponent(shareTitle);

  const shareOptions = [
    {
      name: "WhatsApp",
      icon: "fab fa-whatsapp",
      color: "#25D366",
      href: `https://wa.me/?text=${encodedTitle}%20${encodedUrl}`,
    },
    {
      name: "Facebook",
      icon: "fab fa-facebook-f",
      color: "#1877F2",
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    },
    {
      name: "X",
      icon: "fab fa-x-twitter",
      color: "#000000",
      href: `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`,
    },
    {
      name: "Telegram",
      icon: "fab fa-telegram",
      color: "#229ED9",
      href: `https://t.me/share/url?url=${encodedUrl}&text=${encodedTitle}`,
    },
  ];

  return (
    <article className="bg-white border border-gray-200 p-6 rounded-2xl shadow-sm hover:shadow-lg transition-shadow relative">

      {/* CATEGORY & SHARE */}
      <div className="flex items-center justify-between mb-3">
        {(article.state || article.category) && (
          <span className="inline-block bg-teal-50 text-brand-red text-xs font-bold px-3 py-1 rounded-full border border-purple-100">
            {article.state ? article.state : article.category}
          </span>
        )}

        <div className="flex gap-3">
          {article.youtube_url && (
            <a
              href={article.youtube_url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#FF0000] hover:opacity-80 transition"
            >
              <i className="fab fa-youtube text-lg"></i>
            </a>
          )}
          <button
            onClick={handleShare}
            className="text-gray-400 hover:text-[#4600a3] transition"
            title="Share"
          >
            <i className="fa-solid fa-share-nodes text-lg"></i>
          </button>
        </div>
      </div>

      {/* TITLE */}
      <h1 className="text-2xl md:text-3xl leading-tight font-black text-gray-900 mb-3 tracking-tight">
        {article.news_title}
      </h1>

      {/* REPORTER SECTION */}
      {(article.reporter_name || article.reporter_image) && (
        <div className="flex items-center gap-3 mb-4 text-sm text-gray-500 font-medium">
          {article.reporter_image && !reporterImgError ? (
            <img
              src={
                article.reporter_image?.startsWith("/images/")
                  ? article.reporter_image
                  : article.reporter_image?.startsWith("http")
                  ? article.reporter_image
                  : `${getMediaBaseUrl()}/uploads/news/${encodeURIComponent(article.reporter_image)}`
              }
              alt={article.reporter_name}
              className="w-8 h-8 rounded-full object-cover border border-gray-200"
              onError={() => setReporterImgError(true)}
            />
          ) : (
            <div className="w-8 h-8 rounded-full bg-gray-100 border border-gray-200 flex items-center justify-center text-gray-400 shrink-0">
              <i className="fa-solid fa-user text-sm"></i>
            </div>
          )}
          <span>
            {article.reporter_name}
          </span>
        </div>
      )}

      {/* IMAGE */}
      {article.thumbnail && (
        <div className="mb-6">
          <img
            src={
              article.thumbnail?.startsWith("/images/")
                ? article.thumbnail
                : article.thumbnail?.startsWith("http")
                ? article.thumbnail
                : `${getMediaBaseUrl()}/uploads/news/${encodeURIComponent(article.thumbnail)}`
            }
            alt={article.news_title}
            className="w-full rounded-xl object-cover max-h-[400px]"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/no-image.png";
            }}
          />

          <div className="flex items-center gap-4 mt-3">
            {article.youtube_url && (
              <a
                href={article.youtube_url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm font-semibold text-[#4600a3] bg-purple-50 border border-purple-100 px-4 py-1.5 rounded-full hover:bg-purple-100 transition"
              >
                <i className="fab fa-youtube text-lg"></i>
                <span>YouTube</span>
              </a>
            )}

            <button
              onClick={() => handleListen(rawDescription)}
              className="flex items-center gap-2 text-sm font-semibold text-gray-700 bg-gray-100 border border-gray-200 px-4 py-1.5 rounded-full hover:bg-gray-200 transition"
            >
              <i className="fa-solid fa-volume-high text-lg"></i>
              <span>Listen</span>
            </button>
          </div>
        </div>
      )}

      {/* DESCRIPTION */}
      {!showMore && previewText && (
        <p className="text-gray-700 text-[17px] mb-4 leading-relaxed whitespace-pre-wrap text-justify">
          {previewText}
          {remainingText && <span>...</span>}
        </p>
      )}

      {/* FULL TEXT */}
      {showMore && (
        <p className="text-gray-700 text-[17px] leading-relaxed mb-4 whitespace-pre-wrap text-justify">
          {rawDescription}
        </p>
      )}

      {/* READ MORE LINK */}
      {!isDetail && (
        <div className="mt-6 flex justify-between items-center border-t border-gray-100 pt-4">
          <Link
            to={`/news/${article.id}`}
            className="text-[#4600a3] text-sm font-bold hover:text-purple-800 transition flex items-center gap-2 group"
          >
            à¤ªà¥‚à¤°à¥€ à¤–à¤¬à¤° à¤ªà¤¢à¤¼à¥‡à¤‚
            <i className="fa-solid fa-arrow-right group-hover:translate-x-1 transition-transform"></i>
          </Link>
        </div>
      )}

      {/* ================= SHARE MODAL ================= */}
      {showShare && (
        <div
          className="fixed inset-0 z-[9999] bg-black/70 flex items-center justify-center p-4"
          onClick={() => setShowShare(false)}
        >
          <div
            className="bg-white rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100">
              <h3 className="text-base font-black text-gray-900">à¤‡à¤¸ à¤–à¤¬à¤° à¤•à¥‹ à¤¶à¥‡à¤¯à¤° à¤•à¤°à¥‡à¤‚</h3>
              <button
                onClick={() => setShowShare(false)}
                className="w-7 h-7 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 text-gray-600"
              >
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>

            {getThumbnailUrl() && (
              <img
                src={getThumbnailUrl()}
                alt={article.news_title}
                className="w-full h-40 object-cover"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.style.display = "none";
                }}
              />
            )}

            <div className="p-5">
              <p className="text-sm font-bold text-gray-800 leading-snug line-clamp-2 mb-4">
                {article.news_title}
              </p>

              <div className="grid grid-cols-2 gap-3">
                {shareOptions.map((opt) =>
                  opt.name === "WhatsApp" ? (
                    <button
                      key={opt.name}
                      onClick={handleWhatsAppShare}
                      className="flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm font-semibold text-white transition hover:opacity-85"
                      style={{ backgroundColor: opt.color }}
                    >
                      <i className={`${opt.icon} text-lg`}></i>
                      <span>{opt.name}</span>
                    </button>
                  ) : (
                    <a
                      key={opt.name}
                      href={opt.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() => setShowShare(false)}
                      className="flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm font-semibold text-white transition hover:opacity-85"
                      style={{ backgroundColor: opt.color }}
                    >
                      <i className={`${opt.icon} text-lg`}></i>
                      <span>{opt.name}</span>
                    </a>
                  )
                )}
              </div>

              <button
                onClick={handleCopyImageAndLink}
                className="flex items-center justify-center gap-2 px-3 py-2.5 rounded-xl text-sm font-semibold text-white bg-[#4600a3] hover:opacity-90 transition mb-3"
              >
                <i className="fa-solid fa-image"></i>
                <span>à¤¥à¤‚à¤¬à¤¨à¥‡à¤² + à¤²à¤¿à¤‚à¤• à¤•à¥‰à¤ªà¥€ à¤•à¤°à¥‡à¤‚</span>
              </button>

              <div className="grid grid-cols-2 gap-3">
                <button
                  onClick={handleCopyLink}
                  className="flex items-center justify-center gap-2 px-3 py-2.5 rounded-xl text-sm font-semibold text-gray-700 bg-gray-100 border border-gray-200 hover:bg-gray-200 transition"
                >
                  <i className="fa-solid fa-link"></i>
                  <span>à¤²à¤¿à¤‚à¤• à¤•à¥‰à¤ªà¥€ à¤•à¤°à¥‡à¤‚</span>
                </button>

                {navigator.share && (
                  <button
                    onClick={handleNativeShare}
                    className="flex items-center justify-center gap-2 px-3 py-2.5 rounded-xl text-sm font-semibold text-gray-700 bg-gray-100 border border-gray-200 hover:bg-gray-200 transition"
                  >
                    <i className="fa-solid fa-share-nodes"></i>
                    <span>à¤”à¤° à¤µà¤¿à¤•à¤²à¥à¤ª</span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </article>
  );
};

export default Profilecard;
